import { FC } from "react";

interface ChainIconSVGProps {
    className?: string;
}

const ChainIconSVG: FC<ChainIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="36"
            height="37"
            viewBox="0 0 36 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.0003 20.0019C15.6445 20.8631 16.4663 21.5757 17.4101 22.0913C18.3539 22.6069 19.3976 22.9136 20.4703 22.9904C21.543 23.0672 22.6197 22.9125 23.6273 22.5366C24.635 22.1607 25.55 21.5725 26.3103 20.8119L30.8103 16.3119C32.1765 14.8974 32.9324 13.0029 32.9154 11.0364C32.8983 9.06992 32.1095 7.18882 30.7189 5.79826C29.3284 4.4077 27.4473 3.61893 25.4808 3.60185C23.5143 3.58476 21.6198 4.34072 20.2053 5.7069L17.6253 8.2719M21.0003 17.0019C20.3561 16.1407 19.5343 15.4281 18.5905 14.9125C17.6467 14.3969 16.603 14.0902 15.5303 14.0134C14.4576 13.9366 13.3809 14.0914 12.3733 14.4672C11.3656 14.8431 10.4506 15.4313 9.6903 16.1919L5.1903 20.6919C3.82411 22.1064 3.06816 24.0009 3.08524 25.9674C3.10233 27.9339 3.8911 29.815 5.28166 31.2055C6.67222 32.5961 8.55331 33.3849 10.5198 33.402C12.4863 33.419 14.3808 32.6631 15.7953 31.2969L18.3603 28.7319"
                stroke="currentColor"
                strokeWidth="2.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ChainIconSVG;
